import React from 'react'
import AboutSection from '../AboutPage/AboutSection'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faArrowRight, faHeart } from '@fortawesome/free-solid-svg-icons';
import "./blog.css"
import Blogblog from './Blogblog';
import { postdata } from '../DUMMYDATA/DUMMYDATA';
const bg4 = '../images/bg/bg4.webp';

const Blog = () => {
  return (
    <>
      <AboutSection data="BLOG" backgroundImage={bg4}/>
      <Blogblog data={postdata}/>
      
    </>
  )
}

export default Blog